import React from 'react';
import './Finance.scss';
import MolLink from '../../Basepage/parts/Menu/MolLink';

interface ZahlungenProp {
  data: any;
  apiBase: string;
}
interface ZahlungenState {
  showPosition: number;
}

export default class Zahlungen extends React.Component<
  ZahlungenProp,
  ZahlungenState
> {
  constructor(prop) {
    super(prop);
    this.state = { showPosition: 10 };
  }

  render(): React.ReactNode {
    let tage = Object.keys(this.props.data.transactions);
    let tageRechungen: string[] = [];
    for (let index = 0; index < tage.length; index++) {
      if (this.props.data.transactions[tage[index]].zahlungen.length > 0) {
        tageRechungen.push(tage[index]);
      }
    }

    let tageCount = tageRechungen.length;
    let showTage = tageRechungen.reverse().slice(0, this.state.showPosition);
    let rows: JSX.Element[] = [];

    let financeTd = (number) => {
      return (
        <td style={{ textAlign: 'right', verticalAlign: 'top' }}>
          {new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
          }).format(number)}
        </td>
      );
    };

    showTage.map((item, index) => {
      let dayTransction = this.props.data.transactions[item];

      for (
        let z_index = 0;
        z_index < dayTransction.zahlungen.length;
        z_index++
      ) {
        let rowId = 'zahlung_' + item + '_' + z_index + '_' + rows.length;
        let classname = 'row ' + (rows.length % 2 == 0 ? 'mod2' : '');
        let lastRow = dayTransction.zahlungen.length - 1 == z_index;
        if (lastRow) {
          classname += ' last';
        }

        let zahlungRow = (
          <tr className={classname} key={rowId} id={rowId}>
            {z_index == 0 ? (
              <td
                rowSpan={dayTransction.zahlungen.length}
                style={{
                  background: 'white',
                  borderBottom: 'solid 1px black',
                }}
              >
                {new Date(item).toLocaleDateString('de-DE', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                })}
              </td>
            ) : null}
            <td>
              {dayTransction.zahlungen[z_index].kname == 'Vorkasse'
                ? 'Zahlung'
                : dayTransction.zahlungen[z_index].kname}
            </td>
            {financeTd(dayTransction.zahlungen[z_index].betrag)}
          </tr>
        );
        rows.push(zahlungRow);
      }
    });

    return (
      <div id="Finance">
        <div>
          <table>
            <thead>
              <tr>
                <th>Tag</th>
                <th colSpan={2}>Zahlungen</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r_item, r_index) => r_item)}
              {tageCount > this.state.showPosition ? (
                <tr>
                  <td
                    colSpan={6}
                    style={{ textAlign: 'center', cursor: 'pointer' }}
                    onClick={() => {
                      let newShow = {
                        showPosition: this.state.showPosition + 10,
                      };

                      this.setState(newShow);
                    }}
                  >
                    … weitere Zahlungen
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
